"use strict";

exports.__esModule = true;
exports.styles = void 0;
exports.styles = {
  xs: {
    '& .MuiPaper-root': {
      width: '444px',
      maxWidth: '444px'
    }
  },
  small: {
    '& .MuiPaper-root': {
      width: '600px',
      maxWidth: '600px'
    }
  },
  medium: {
    '& .MuiPaper-root': {
      width: '900px',
      maxWidth: '900px'
    }
  },
  large: {
    '& .MuiPaper-root': {
      width: '1200px',
      maxWidth: '1200px'
    }
  }
};